{
  "version": 1,
  "asset_id": "635e0c45-cc5b-4bc1-8d22-56ecd911af41",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/635e0c45-cc5b-4bc1-8d22-56ecd911af41/wordmark-240.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/635e0c45-cc5b-4bc1-8d22-56ecd911af41/wordmark-240.avif",
  "original_filename": "wordmark-240.avif",
  "size": 6107,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:18:56Z"
}
